import { useEffect, useState } from "react"
import moment from 'moment';

import { FilteringTypes, Filters} from "./Calendar.model"
import { Field } from "../../components/FiltersForm/FiltersForm.model"
import useObjectHelper from "../../Helpers/useObjectHelper"
import { useAuthorizationDataContext } from "../../Helpers/AuthorizationDataProvider";
import { useAuthenticationDataContext } from "../../Helpers/AuthenticationDataProvider";

export const useCalendar = () => {
	const [filters, setFilters] = useState<Filters | null>({
		from: moment(moment.now()).startOf('day'),
		to: moment(moment.now() + 1000 * 60 * 60 * 24 * 7).endOf('day')
	});
	const [showMobileFilters, setShowMobileFilters] = useState(false);
	const [showScheduleEventPopup, setShowScheduleEventPopup] = useState(false);
	const [activeTabKey, setActiveTabKey] = useState('1');

	const { cleanObj } = useObjectHelper();
	const { isAuthorized } = useAuthorizationDataContext();
	const { userId } = useAuthenticationDataContext();

	const filterDefaultValues: Record<FilteringTypes, any> = {
		date: undefined,
		from: moment(moment.now()).startOf('day'),
		to: moment(moment.now() + 1000 * 60 * 60 * 24 * 7).endOf('day'),
	}

	const filterFields: Field<Record<FilteringTypes, any>>[] = [
		{
			label: 'from',
			name: 'from',
			type: 'date'
		},
		{
			label: 'to',
			name: 'to',
			type: 'date'
		}
	];
 
	const recordingsFilterFields: Field<Record<FilteringTypes, any>>[] = [
		{
			label: 'date',
			name: 'date',
			type: 'date',
		}
	]

	useEffect(() => {
		setFilters(filterDefaultValues);
	}, []);

	const onSubmitFilters = async (data: Filters) => {
	 
		const filters: Filters = {
			...cleanObj(data)
		};

		setFilters(filters);
	}

	const onResetFilters = () => {
		setFilters(filterDefaultValues);
	}

	const onTabChange = (tab: string) => {
		setActiveTabKey(tab);
	}

	const toggleMobileFilters = () => {
		setShowMobileFilters((currentValue) => !currentValue);
	}

	const togglePopup = (setStateFunction: React.Dispatch<React.SetStateAction<boolean>>) => {
		setStateFunction((currentValue: boolean) => !currentValue);
	}

	return {
		isAuthorized,
		onResetFilters,
		onSubmitFilters,
		onTabChange,
		state: {
			activeTabKey,
			filterDefaultValues,
			filterFields,
			filters,
			recordingsFilterFields,
			showMobileFilters,
			showScheduleEventPopup,
			userId
		},
		toggleMobileFilters,
		toggleScheduleEventPopup: () => {
			togglePopup(setShowScheduleEventPopup);
		},
	}
}